import Axios from './axios_wrapper'

export function getHospitalsByName(name) {
  return Axios({
    url: `/google/places?name=${name}`,
    method: 'GET'
  })
}

export function getHospitalByID(id) {
  return Axios({
    url: `/google/places/${id}`,
    method: 'GET'
  })
}


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/google.js
// module id = null
// module chunks = 